import '../estilos/crearEditar.css';
import { pixelClickLlamarAyuda, pixelClickWhatsAppAyuda } from '../funcionesDatos/pixelFacebook';
import { gtagClickLlamarAyuda, gtagClickWhatsAppAyuda } from '../funcionesDatos/pixelGoogle';
import { eventoClickLlamarAyuda, eventoClickWhatsAppAyuda } from '../funcionesDatos/eventoPropio';

function CardAyudarACrear({ className = "mb-4", usuarioId = null }) {
  return (
    <>
    <div className={`rounded-3 p-3 ${className}`} style={{ background: 'var(--color-bg-surface-alt)', border: '1.5px solid var(--azul-claro-borde)' }}>
      <p className="fw-bold mb-1">¿No sabes cómo crear tu servicio? ¡Nosotros lo hacemos por ti!</p>
      <p className="text-muted mb-3" style={{ fontSize: '14px' }}>
        Cuéntanos a qué te dedicas y nosotros nos encargamos del resto.
      </p>
      <div className="row g-2">
        <div className="col-6">
          <a href="tel:+573189859423" className="btn btn-dark rounded-pill fw-bold d-flex align-items-center justify-content-center gap-2 w-100 caa-tel" onClick={() => { pixelClickLlamarAyuda({ numero: "3189859423" }); gtagClickLlamarAyuda({ numero: "3189859423" }); eventoClickLlamarAyuda({ numero: "3189859423", usuarioId }); }}>
            <i className="bi bi-telephone-fill"></i>318 985 9423
          </a>
        </div>
        <div className="col-6">
          <a href="tel:+573124964754" className="btn btn-dark rounded-pill fw-bold d-flex align-items-center justify-content-center gap-2 w-100 caa-tel" onClick={() => { pixelClickLlamarAyuda({ numero: "3124964754" }); gtagClickLlamarAyuda({ numero: "3124964754" }); eventoClickLlamarAyuda({ numero: "3124964754", usuarioId }); }}>
            <i className="bi bi-telephone-fill"></i>312 496 4754
          </a>
        </div>
        <div className="col-12">
          <a
            href="https://wa.me/573189859423?text=Hola%2C%20quiero%20que%20me%20ayuden%20a%20crear%20mi%20servicio%20en%20Zervicy"
            className="btn rounded-pill fw-bold w-100 d-flex align-items-center justify-content-center gap-2 caa-wapp"
            style={{ backgroundColor: 'var(--verde-whatsapp)', color: 'white', border: 'none' }}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => { pixelClickWhatsAppAyuda(); gtagClickWhatsAppAyuda(); eventoClickWhatsAppAyuda({ usuarioId }); }}
          >
            <i className="bi bi-whatsapp"></i>
            <span className="d-none d-sm-inline fw-bold">O haz clic y te ayudamos por WhatsApp</span>
            <span className="d-inline d-sm-none fw-bold">Te ayudamos por WhatsApp</span>
          </a>
        </div>
      </div>
    </div>
    </>
  );
}

export default CardAyudarACrear;
